import type { VoiceCallRecord } from "@/types/v2/voice"

// Terminal-state predicates for a backend VoiceCall record.
// Mirrors `VoiceCall::TERMINAL_STATUSES` — the server is the
// source of truth for whether a call is over (CON-211).
const TERMINAL_STATUSES = new Set([
  "completed",
  "missed",
  "declined",
  "failed",
])

export function isTerminalVoiceCall(
  voiceCall: VoiceCallRecord,
): boolean {
  return (
    voiceCall.endedAt != null ||
    TERMINAL_STATUSES.has(voiceCall.status)
  )
}

// A call that actually reached the customer and then ended —
// the only kind the after-call workflow card logs. Unconnected
// terminals (missed/declined/failed) route through the
// softphone's "couldn't connect" surface instead.
export function isConnectedTerminalVoiceCall(
  voiceCall: VoiceCallRecord,
): boolean {
  return isTerminalVoiceCall(voiceCall) && voiceCall.answeredAt != null
}
